import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { updateSelectedReportWizardStep } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { setTalkingPoints } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/talking-points/talking-points.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { setFolderableOperation } from 'FoldersApp/state/folderable-operation/folderable-operation.action';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { getCurrentWizardStep, getCurrentWizardStepIndex, getTalkingPoints, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { FolderableOperationValue } from 'FoldersApp/state/folderable-operation/folderable-operation-value.enum';
import { ItemSelectionService } from 'Angular/services/item-selection.service';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "Angular/services/item-selection.service";
import * as i3 from "../../../../../../../../talking_points/static/talking_points/ts/features/talking-points-multi-select-saved-modal/talking-points-multi-select-saved-modal/talking-points-multi-select-saved-modal.component";
function SelectTalkingPointsModalComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-talking-points-multi-select-saved-modal", 1);
    i0.ɵɵlistener("backHandler", function SelectTalkingPointsModalComponent_Conditional_0_Template_ycn_talking_points_multi_select_saved_modal_backHandler_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.back()); })("cancelHandler", function SelectTalkingPointsModalComponent_Conditional_0_Template_ycn_talking_points_multi_select_saved_modal_cancelHandler_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.cancel()); })("selectionHandler", function SelectTalkingPointsModalComponent_Conditional_0_Template_ycn_talking_points_multi_select_saved_modal_selectionHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleSelection($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("maxItems", ctx_r1.maxItems)("showBackButton", true);
} }
/**
 * Select Talking Points Modal Component
 *
 * Used for editing the Talking Points used for a module in the Custom PDF Reports in the wizard steps
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when the wizard should move to the previous step or next step.
 *
 */
export class SelectTalkingPointsModalComponent {
    constructor(store, itemSelectionService) {
        this.store = store;
        this.itemSelectionService = itemSelectionService;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.currentWizardStep = null;
        this.mapStateToComponent = (state) => {
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.currentWizardStep = getCurrentWizardStep(state);
            if (this.currentWizardStepIndex === 0 &&
                this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_EDIT_TALKING_POINTS_MODAL) {
                this.openModal();
            }
            else if (!this.currentWizardStep) {
                this.editTalkingPointsModalStepIndex = 0;
            }
            if (this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_EDIT_TALKING_POINTS_MODAL) {
                if (this.currentWizardStep.modules === undefined) {
                    this.modules = [];
                }
                else {
                    this.modules = this.currentWizardStep.modules;
                }
            }
            this.talkingPointsModuleMap = getTalkingPoints(state);
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        if (!this.editTalkingPointsModalStepIndex) {
            this.editTalkingPointsModalStepIndex = 0;
        }
        if (this.modules?.length) {
            const talkingPointsModuleMap = cloneDeep(this.talkingPointsModuleMap);
            Object.values(this.modules).forEach((module) => {
                if (talkingPointsModuleMap[module.module_type] === undefined) {
                    talkingPointsModuleMap[module.module_type] = {};
                }
                const module_id = module.id || module.step_uuid;
                if (module_id && talkingPointsModuleMap[module.module_type][module_id] === undefined) {
                    talkingPointsModuleMap[module.module_type][module_id] = [];
                }
            });
            this.store.dispatch(setTalkingPoints({ talkingPoints: talkingPointsModuleMap }));
        }
        const module = this.modules?.[this.editTalkingPointsModalStepIndex];
        if (module) {
            const module_id = module.id || module.step_uuid;
            const talkingPoints = this.talkingPointsModuleMap[module.module_type][module_id];
            this.itemSelectionService.clearSelections();
            this.itemSelectionService.selectItems(talkingPoints);
            this.maxItems = module.max_talking_points;
        }
        Promise.resolve().then(() => this.store.dispatch(setFolderableOperation({ operation: FolderableOperationValue.MULTI_SELECT })));
    }
    back() {
        if (this.editTalkingPointsModalStepIndex > 0) {
            this.editTalkingPointsModalStepIndex -= 1;
            this.openModal();
        }
        else {
            this.store.dispatch(decrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
    }
    cancel() {
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    handleSelection(items) {
        const module = this.modules[this.editTalkingPointsModalStepIndex];
        const talkingPointsModuleMap = cloneDeep(this.talkingPointsModuleMap);
        if (talkingPointsModuleMap[module.module_type] === undefined) {
            talkingPointsModuleMap[module.module_type] = {};
        }
        const module_id = module.id || module.step_uuid;
        talkingPointsModuleMap[module.module_type][module_id] = items;
        this.store.dispatch(setTalkingPoints({ talkingPoints: talkingPointsModuleMap }));
        const updatedWizardStep = cloneDeep(this.currentWizardStep);
        if (updatedWizardStep?.modules !== undefined) {
            updatedWizardStep.modules[this.editTalkingPointsModalStepIndex].previously_selected = items.map((item) => item.id);
            this.store.dispatch(updateSelectedReportWizardStep({ newStep: updatedWizardStep }));
        }
        if (this.editTalkingPointsModalStepIndex + 1 < this.modules.length) {
            this.editTalkingPointsModalStepIndex += 1;
            this.openModal();
        }
        else {
            this.store.dispatch(incrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
    }
}
SelectTalkingPointsModalComponent.ɵfac = function SelectTalkingPointsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectTalkingPointsModalComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ItemSelectionService)); };
SelectTalkingPointsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectTalkingPointsModalComponent, selectors: [["ycn-select-talking-points-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, features: [i0.ɵɵProvidersFeature([ItemSelectionService])], decls: 1, vars: 1, consts: [[3, "maxItems", "showBackButton"], [3, "backHandler", "cancelHandler", "selectionHandler", "maxItems", "showBackButton"]], template: function SelectTalkingPointsModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, SelectTalkingPointsModalComponent_Conditional_0_Template, 1, 2, "ycn-talking-points-multi-select-saved-modal", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.currentWizardStep ? 0 : -1);
    } }, dependencies: [i3.TalkingPointsMultiSelectSavedModalComponent], encapsulation: 2 });
